import { useContext } from "react";
import NoteGridPanel from "../../../common/notes/components/NoteGridPanel";
import { WorkOrderContext } from "../context/WorkOrderContext";

export default function WorkOrderNotesPanel(props: { height?: string | number }) {

	const { order } = useContext(WorkOrderContext);

	return (
		<NoteGridPanel
			notes={order.details.notes}
			height={props.height}
		/>
	)
}
